var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.115 2H8.635C5.875 2 4.875 3 4.875 5.81V18.19C4.875 21 5.875 22 8.635 22H17.105C19.875 22 20.875 21 20.875 18.19V5.81C20.875 3 19.875 2 17.115 2ZM12.875 19.3C11.915 19.3 11.125 18.51 11.125 17.55C11.125 16.59 11.915 15.8 12.875 15.8C13.835 15.8 14.625 16.59 14.625 17.55C14.625 18.51 13.835 19.3 12.875 19.3ZM14.875 6.25H10.875C10.465 6.25 10.125 5.91 10.125 5.5C10.125 5.09 10.465 4.75 10.875 4.75H14.875C15.285 4.75 15.625 5.09 15.625 5.5C15.625 5.91 15.285 6.25 14.875 6.25Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.fc5da26a07efc587a84b83ec5efdb7b3.svg";
export { ForwardRef as ReactComponent };